import { Roles } from '../constants/roles';
import { RolesTypes } from './roles';

export const Permissions = {
	[Roles.SuperAdmin]: [RolesTypes.All],
	[Roles.Compliance]: [
		RolesTypes.Investors,
		RolesTypes.Borrowers,
		RolesTypes.Reports,
		RolesTypes.Loans,
		RolesTypes.ControlPanelAmlList,
		RolesTypes.ControlPanelClient,
		RolesTypes.ControlPanelAmlReport,
		RolesTypes.Transactions,
		RolesTypes.Buckets,
		RolesTypes.PromotionalCode,
		RolesTypes.AutoInvestment,
		RolesTypes.ControlPanelAdminUsers,
		RolesTypes.DisburseButton
	],
	[Roles.Credit]: [
		RolesTypes.Investors,
		RolesTypes.Borrowers,
		RolesTypes.Reports,
		RolesTypes.Loans,
		RolesTypes.ControlPanelAmlList,
		RolesTypes.ControlPanelClient,
		RolesTypes.ControlPanelAmlReport,
		RolesTypes.Transactions,
		RolesTypes.Buckets,
		RolesTypes.PromotionalCode,
		RolesTypes.AutoInvestment,
		RolesTypes.ControlPanelAdminUsers,
		RolesTypes.DisburseButton
	],
	[Roles.AccountManager]: [
		RolesTypes.Investors,
		RolesTypes.Borrowers,
		RolesTypes.Reports,
		RolesTypes.Loans,
		RolesTypes.ControlPanelAmlList,
		RolesTypes.ControlPanelClient,
		RolesTypes.ControlPanelAmlReport,
		RolesTypes.Transactions,
		RolesTypes.TransactionActions,
		RolesTypes.TransactionCreation,
		RolesTypes.BlogArticleCRUD,
		RolesTypes.ComparisonCRUD,
		RolesTypes.BlogCategoryCRUD,
		RolesTypes.FAQCategoryCRUD,
		RolesTypes.FAQItemsCRUD,
		RolesTypes.TeamMemberCRUD,
		RolesTypes.PushNotifications,
		RolesTypes.Buckets,
		RolesTypes.PromotionalCode,
		RolesTypes.AutoInvestment,
		RolesTypes.ControlPanelWelcomeBonus,
		RolesTypes.ControlPanelAdminUsers,
		RolesTypes.DisburseButton
	],
	[Roles.SEOManager]: [
		RolesTypes.BlogArticleCRUD,
		RolesTypes.ComparisonCRUD,
		RolesTypes.BlogCategoryCRUD,
		RolesTypes.FAQCategoryCRUD,
		RolesTypes.FAQItemsCRUD,
		RolesTypes.TeamMemberCRUD,
		RolesTypes.ControlPanelMetaTags,
		RolesTypes.ControlPanelAdminUsers
	],
};
